/**
 * @generated SignedSource<<185042c54a02c45b72980e757b6e0db8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type BannedScreenQuery$variables = Record<PropertyKey, never>;
export type BannedScreenQuery$data = {
  readonly currentUser: {
    readonly status: UserStatus;
  } | null | undefined;
};
export type BannedScreenQuery = {
  response: BannedScreenQuery$data;
  variables: BannedScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BannedScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BannedScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea69b1b0a482804d716a1f4a9fc2dcca",
    "id": null,
    "metadata": {},
    "name": "BannedScreenQuery",
    "operationKind": "query",
    "text": "query BannedScreenQuery {\n  currentUser {\n    status\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f28a099d363f55fcdfcc70d3945d839";

export default node;
